import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {TechnicalDeviceTechnicalCardApiService} from '@api/technical-device-technical-card.api.service';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Получение списка доступных специалистов для выбора в подписантах
 * Специалисты зависят от техкарты, для которой делается заключение
 */

@Injectable()
export class ConclusionSignersSpecialistsListResolver extends BaseResolverService {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        service: TechnicalDeviceTechnicalCardApiService,
        router: Router,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const service = this.resolverService as TechnicalDeviceTechnicalCardApiService;
        const { technicalCardId } = snapshot.parent.params;
        return {
            url: service.getSignersSpecialistsListPath(technicalCardId)
        };
    }
}
